import generateTailwindVariableClasses from "@/Common/helpers/TailwindCSS";
import clsx from "clsx";
import TypographyCell from "./TypographyCell";
import { TypographyCellProps } from "../types";
import { CELL_FONT_SIZE } from "@/Constants/tables";

interface ICustomCellProps {
	value: string;
	hasTooltip?: boolean;
	maxWith?: number;
	fontSize?: string; // it has to include the unit (px, em, rem, etc)
	fontFamily?: string; // it has to be in Tailwind CSS format
	classes?: string;
	params?: TypographyCellProps["params"];
}

const CustomCell = (props: Readonly<ICustomCellProps>) => {
	const { fontSize = CELL_FONT_SIZE, fontFamily = "font-sans", classes, hasTooltip, value, params } = props;

	return (
		<TypographyCell
			enableOverrideMode
			style={generateTailwindVariableClasses("--fontSize-param", fontSize)}
			className={clsx({
				[`!${fontFamily} truncate`]: true,
				"!text-[length:--fontSize-param] text-default flex flex-col justify-center h-full": true,
				[`!${classes}`]: Boolean(classes),
			})}
			hasTooltip={hasTooltip ?? true}
			tooltipProps={{ title: value }}
			params={params}
		>
			{value}
		</TypographyCell>
	);
};

export default CustomCell;
